
// dev
const appConst = {
    authServerUrl: "https://api.open65.live",
 //authServerUrl: "http://localhost:4035",

  cropImgUrl: "http://localhost/80",
  directImgUrl: "http://localhost/80",

 apiUrl: "https://api.open65.live",
   // apiUrl: "http://localhost:4035",
  apiUrlEng: "http://api.dd.news",
  cdnUrl: "http://api.dd.news",
  siteLink: "http://www.dd.news",
  videoSiteLink: "http://localhost/80",
  clientId: "2",
  banglaDirectImg: "https://localhost/80",
  clientSecret: "gv2f4SbmfEI7y2YQ4JHAmTyB0KhgkkkxwVxtRXoV",
  encryptionSalt: "8F=k5K+79eQ3aPVA",
  dt_public_post_nonce: "dt_public_post_nonce",
  chunkSize: 204800,//1048576,
  isBangla: false,
  dataKeys: {
    dt_bn_posts: 'dt_en_posts',
    dt_bn_categories: 'dt_en_categories',
    dt_bn_parent_categories: 'dt_en_parent_categories',
    dt_bn_tags: 'dt_en_tags',
    dt_bn_topics: 'dt_en_topics'
  }
};

export default appConst;
